var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 288A202.667 202.667 0 0 1 373.333 85.333h320A202.667 202.667 0 0 1 896 288v192a32 32 0 0 1-64 0V288a138.667 138.667 0 0 0-138.667-138.667h-320A138.667 138.667 0 0 0 234.667 288v448a138.667 138.667 0 0 0 138.666 138.667H416a32 32 0 0 1 0 64h-42.667A202.667 202.667 0 0 1 170.667 736V288z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 576a32 32 0 0 1 32-32h234.667a32 32 0 0 1 0 64H352a32 32 0 0 1-32-32z m0-192a32 32 0 0 1 32-32h320a32 32 0 0 1 0 64H352a32 32 0 0 1-32-32z m399.36 201.813a92.97 92.97 0 1 1 131.413 131.414l-207.957 208a57.728 57.728 0 0 1-40.832 16.938h-49.792a57.77 57.77 0 0 1-57.728-57.77v-49.792a57.705 57.705 0 0 1 16.896-40.832l208-207.958z m86.187 45.227a28.97 28.97 0 0 0-40.96 0L558.464 837.205v40.96h40.96L805.504 672a28.97 28.97 0 0 0 0-40.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessments);
export default __webpack_public_path__ + "static/media/assessments.ef291e3121ec1890d9d8cc91276199e2.svg";
export { ForwardRef as ReactComponent };